import { useCallback, useEffect, useState } from "react";
import { CHAVE_TOKEN } from "../../../utils/formata";

// FUNIL DE PERGUNTAS (Dani, 20/09: "uma sessão no atendimento com o funil das perguntas, e quero que siga à risca,
// quero que dê para editar, adicionar etc"). A ordem daqui é a ordem que o robô segue: ele pega pela ponte
// (functions/ponte) em até 30 s e passa a perguntar exatamente isto, uma pergunta por mensagem.
// Pergunta de fábrica (campo sem "extra_") tem regra de código junto — por isso ela edita o texto, liga/desliga e
// reordena, mas o campo continua o mesmo. Pergunta nova (extra_) é livre: a resposta fica guardada como texto.
const cor = { ouro: "#d4af37", ouroClaro: "#e8c95c", verde: "#2ecc71", vermelho: "#ff6b5b", texto: "#f3f4f6", suave: "#a3aec0", fundo: "#0f1e2e", fundoClaro: "#1b2b40", linha: "#24344d" };
const cartao = { background: cor.fundo, border: `1px solid ${cor.linha}`, borderRadius: 12, padding: "12px 14px", minWidth: 0 };
const rotuloCampo = { color: cor.suave, fontSize: "0.72rem", letterSpacing: 0.6, textTransform: "uppercase" };
const linkBotao = { background: "none", border: 0, color: cor.ouro, fontSize: "0.8rem", padding: "4px 6px", cursor: "pointer", whiteSpace: "nowrap" };
const quadrado = { width: 34, height: 34, borderRadius: 8, border: `1px solid ${cor.linha}`, background: cor.fundoClaro, color: cor.texto, cursor: "pointer", flex: "none", fontSize: "1rem", lineHeight: 1 };

// o que cada pergunta de fábrica faz por baixo — a Dani precisa saber antes de desligar
const AVISO = {
  temLocal: "Decide se a Help atende: quem não tem ponto nem trabalha de casa é dispensado com carinho.",
  temCnpj: "Só aparece para quem tem ponto físico ou trabalha de casa.",
  cnpj: "Só aparece para quem respondeu que TEM CNPJ. O número é conferido (dígito errado ela pede de novo).",
  cidade: "Usada para escolher o grupo de visitas da região.",
  valorPrincipal: "Vira o valor da proposta.",
  numParcelas: "Vira o plano de diárias da proposta.",
  nomeFantasia: "Vira o nome do negócio no cadastro.",
};
const ehExtra = (campo) => String(campo || "").startsWith("extra_");
const semAcento = (s) => String(s || "").normalize("NFD").replace(/[̀-ͯ]/g, "");

async function ponte(caminho, { metodo = "GET", corpo = null } = {}) {
    let token = "";
    try { token = localStorage.getItem(CHAVE_TOKEN) || ""; } catch {}
    const ctrl = new AbortController();
    const t = setTimeout(() => ctrl.abort(), 20000);
    try {
        const r = await fetch("/ponte" + caminho, {
            method: metodo,
            headers: { Authorization: `Bearer ${token}`, ...(corpo ? { "Content-Type": "application/json" } : {}) },
            body: corpo ? JSON.stringify(corpo) : undefined,
            signal: ctrl.signal,
        });
        const j = await r.json().catch(() => ({ ok: false, mensagem: `resposta inválida (${r.status})` }));
        return { httpStatus: r.status, ...j };
    } catch (e) {
        return { ok: false, mensagem: e.name === "AbortError" ? "Demorou demais pra responder." : "Sem conexão com o painel." };
    } finally {
        clearTimeout(t);
    }
}

export default function FunilPerguntas() {
    const [carregando, setCarregando] = useState(true);
    const [erro, setErro] = useState("");
    const [aviso, setAviso] = useState("");
    const [salvando, setSalvando] = useState(false);
    const [padrao, setPadrao] = useState([]);
    const [passos, setPassos] = useState([]);
    const [salvo, setSalvo] = useState([]); // o que está valendo no robô agora
    const [roboConectado, setRoboConectado] = useState(false);
    const [novo, setNovo] = useState({ rotulo: "", pergunta: "" });

    const carregar = useCallback(async () => {
        setCarregando(true);
        const r = await ponte("/funil");
        setCarregando(false);
        if (!r.ok) return setErro(r.httpStatus === 401 ? "Faça login no painel de novo." : r.mensagem || "Não consegui carregar o funil.");
        setErro("");
        setRoboConectado(!!r.roboConectado);
        const base = (r.padrao || []).map((p) => ({ ...p, ativo: true }));
        setPadrao(base);
        const lista = r.funil?.passos?.length ? r.funil.passos : base;
        setPassos(lista.map((p) => ({ ...p, ativo: p.ativo !== false })));
        setSalvo(lista.map((p) => ({ ...p, ativo: p.ativo !== false })));
    }, []);

    useEffect(() => { carregar(); }, [carregar]);

    const mudou = JSON.stringify(passos) !== JSON.stringify(salvo);
    const mexer = (i, mudanca) => setPassos((l) => l.map((p, j) => (i === j ? { ...p, ...mudanca } : p)));
    const mover = (i, d) => setPassos((l) => {
        const n = [...l];
        const alvo = i + d;
        if (alvo < 0 || alvo >= n.length) return l;
        [n[i], n[alvo]] = [n[alvo], n[i]];
        return n;
    });
    const remover = (i) => setPassos((l) => l.filter((_, j) => j !== i));

    function adicionar() {
        const rotulo = novo.rotulo.trim();
        const pergunta = novo.pergunta.trim();
        if (!pergunta) return setAviso("Escreva a pergunta que o robô deve fazer.");
        const base = semAcento(rotulo || pergunta).toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_|_$/g, "").slice(0, 24) || "pergunta";
        const usados = new Set(passos.map((p) => p.campo));
        let campo = `extra_${base}`;
        let n = 2;
        while (usados.has(campo)) campo = `extra_${base}_${n++}`;
        setPassos((l) => [...l, { campo, rotulo: rotulo || "pergunta nova", pergunta, ativo: true }]);
        setNovo({ rotulo: "", pergunta: "" });
        setAviso("");
    }

    async function salvar() {
        setSalvando(true);
        const r = await ponte("/funil", { metodo: "PUT", corpo: { passos } });
        setSalvando(false);
        if (!r.ok) return setAviso(r.mensagem || "Não consegui salvar.");
        setSalvo(passos.map((p) => ({ ...p })));
        setAviso("Salvo. O robô passa a seguir este funil em até 30 segundos.");
    }

    const ligadas = passos.filter((p) => p.ativo).length;

    return (
        <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10, flexWrap: "wrap" }}>
                <div style={{ color: cor.suave, fontSize: "0.88rem", maxWidth: 680 }}>
                    Esta é a ordem das perguntas do atendimento. O robô segue exatamente esta lista, uma pergunta por mensagem, e só passa
                    para a seguinte quando a pessoa responde. Você pode mudar o texto, a ordem, desligar uma pergunta ou criar outras.
                    <br />
                    <b style={{ color: cor.texto }}>A pergunta sai com as suas palavras, letra por letra</b> — a IA acolhe e responde o que a pessoa trouxe, mas quem pergunta é você.
                </div>
                <div role="status" style={{ display: "flex", alignItems: "center", gap: 8, fontSize: "0.82rem", color: cor.suave, whiteSpace: "nowrap" }}>
                    <span style={{ width: 10, height: 10, borderRadius: "50%", background: roboConectado ? cor.verde : cor.vermelho, boxShadow: `0 0 8px ${roboConectado ? cor.verde : cor.vermelho}` }}></span>
                    {roboConectado ? "robô conectado" : "robô do escritório desligado"}
                </div>
            </div>

            {erro && <div style={{ ...cartao, borderColor: cor.vermelho, color: cor.vermelho }}>{erro}</div>}
            {carregando ? <div style={{ color: cor.suave }}>carregando…</div> : (
                <>
                    <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                        {passos.map((p, i) => (
                            <section key={p.campo} style={{ ...cartao, opacity: p.ativo ? 1 : 0.55 }}>
                                <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap", marginBottom: 8 }}>
                                    <span style={{ ...rotuloCampo, minWidth: 28 }}>{i + 1}º</span>
                                    <strong style={{ color: cor.texto, fontSize: "0.95rem" }}>{p.rotulo || p.campo}</strong>
                                    {ehExtra(p.campo) ? <span style={{ ...rotuloCampo, color: cor.ouroClaro }}>pergunta sua</span> : <span style={rotuloCampo}>de fábrica</span>}
                                    <span style={{ flex: 1 }}></span>
                                    <button type="button" style={quadrado} onClick={() => mover(i, -1)} disabled={i === 0} aria-label={`Subir ${p.rotulo || p.campo}`}>↑</button>
                                    <button type="button" style={quadrado} onClick={() => mover(i, 1)} disabled={i === passos.length - 1} aria-label={`Descer ${p.rotulo || p.campo}`}>↓</button>
                                    <label style={{ display: "flex", alignItems: "center", gap: 6, margin: 0, color: cor.suave, fontSize: "0.82rem", cursor: "pointer", whiteSpace: "nowrap" }}>
                                        <input type="checkbox" checked={!!p.ativo} onChange={(e) => mexer(i, { ativo: e.target.checked })} style={{ width: 18, height: 18, accentColor: cor.ouro }} />
                                        ligada
                                    </label>
                                    {ehExtra(p.campo) && <button type="button" style={{ ...linkBotao, color: cor.vermelho }} onClick={() => remover(i)}>remover</button>}
                                </div>
                                <label htmlFor={`pergunta-${p.campo}`} style={{ ...rotuloCampo, display: "block", marginBottom: 4 }}>O que o robô pergunta</label>
                                <textarea
                                    id={`pergunta-${p.campo}`} className="form-control" rows={2} value={p.pergunta || ""} maxLength={300}
                                    onChange={(e) => mexer(i, { pergunta: e.target.value })} style={{ fontSize: 16 }}
                                />
                                {AVISO[p.campo] && <div style={{ color: cor.suave, fontSize: "0.78rem", marginTop: 6 }}>{AVISO[p.campo]}</div>}
                            </section>
                        ))}
                    </div>

                    <section style={cartao} aria-labelledby="nova-pergunta">
                        <div id="nova-pergunta" style={{ ...rotuloCampo, marginBottom: 8 }}>Adicionar pergunta</div>
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(100%, 240px), 1fr))", gap: 10 }}>
                            <div>
                                <label htmlFor="novo-rotulo" style={{ ...rotuloCampo, display: "block", marginBottom: 4 }}>Nome curto (só para você)</label>
                                <input id="novo-rotulo" className="form-control" value={novo.rotulo} maxLength={60} placeholder="ex.: ramo do negócio"
                                    onChange={(e) => setNovo((n) => ({ ...n, rotulo: e.target.value }))} style={{ fontSize: 16 }} />
                            </div>
                            <div>
                                <label htmlFor="nova-pergunta-texto" style={{ ...rotuloCampo, display: "block", marginBottom: 4 }}>Pergunta</label>
                                <input id="nova-pergunta-texto" className="form-control" value={novo.pergunta} maxLength={300} placeholder="ex.: Qual é o ramo do seu negócio?"
                                    onChange={(e) => setNovo((n) => ({ ...n, pergunta: e.target.value }))} style={{ fontSize: 16 }} />
                            </div>
                        </div>
                        <button type="button" className="btn btn-outline-he" style={{ marginTop: 10, whiteSpace: "nowrap" }} onClick={adicionar}>
                            <i className="bi bi-plus-lg"></i> Adicionar no fim da lista
                        </button>
                    </section>

                    {aviso && <div style={{ ...cartao, borderColor: /Salvo/.test(aviso) ? cor.verde : cor.vermelho, color: /Salvo/.test(aviso) ? cor.verde : cor.vermelho }} role="status">{aviso}</div>}

                    <div style={{ display: "flex", gap: 10, flexWrap: "wrap", alignItems: "center", justifyContent: "flex-end" }}>
                        <span style={{ color: cor.suave, fontSize: "0.82rem", marginRight: "auto" }}>
                            {ligadas} pergunta{ligadas === 1 ? "" : "s"} ligada{ligadas === 1 ? "" : "s"}{mudou ? " · você tem mudanças não salvas" : ""}
                        </span>
                        <button type="button" className="btn btn-outline-he" style={{ whiteSpace: "nowrap" }} onClick={() => { setPassos(padrao.map((p) => ({ ...p }))); setAviso("Voltou ao padrão de fábrica. Clique em Salvar para o robô seguir."); }}>
                            Voltar ao padrão
                        </button>
                        <button type="button" className="btn btn-outline-he" style={{ whiteSpace: "nowrap" }} onClick={() => { setPassos(salvo.map((p) => ({ ...p }))); setAviso(""); }} disabled={!mudou}>
                            Desfazer
                        </button>
                        <button type="button" className="btn btn-he" style={{ whiteSpace: "nowrap", fontWeight: 800 }} onClick={salvar} disabled={salvando || !mudou}>
                            {salvando ? <span className="spinner-border spinner-border-sm" style={{ marginRight: 8 }}></span> : <i className="bi bi-check-lg" style={{ marginRight: 6 }}></i>}
                            {salvando ? "Salvando…" : "Salvar e mandar pro robô"}
                        </button>
                    </div>
                </>
            )}
        </div>
    );
}
